// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"104":"kindle","152":"device","486":"orders","985":"res"}[chunkId] || chunkId) + "." + {"101":"677b7222","104":"0004afb7","152":"dbcb6663","486":"767b8e21","985":"28d94ad9"}[chunkId] + ".js";
};